import {
  FETCH_DELIVERY_DATA,
  RECEIVE_DELIVERY_DATA,
  FETCH_DELIVERY_DATA_ERROR,
} from "../../actions/PremierPricingTable";

const initialState = {
  deliveryDataFetching: false,
  deliveryDataFetched: false,
  deliveryApiError: false,
};

const PremierPricingTable = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DELIVERY_DATA: {
      return Object.assign({}, state, {
        deliveryDataFetching: true,
        deliveryApiError: false,
      });
    }
    case RECEIVE_DELIVERY_DATA: {
      return Object.assign({}, state, {
        deliveryDataFetching: false,
        deliveryDataFetched: true,
        deliveryData: action.deliveryData,
        deliveryApiError: false,
      });
    }
    case FETCH_DELIVERY_DATA_ERROR: {
      return Object.assign({}, state, {
        deliveryApiError: action.deliveryApiError,
      });
    }
    default: {
      return state;
    }
  }
};

export default PremierPricingTable;
